
import { CalculationRequestTypeEnum } from "../interfaces/calculator/CalculationRequestTypeEnum";
import { CostType } from "../interfaces/calculator/CostType";
import { IPrecatorioCalculator } from "../interfaces/calculator/IPrecatorioCalculator";
import { IPricingCalculatorRequest } from "../interfaces/calculator/IPricingCalculatorRequest";
import { IPricingCalculatorResponse } from "../interfaces/calculator/IPricingCalculatorResponse";
import { IPricingParametersCalculator } from "../interfaces/calculator/IPricingParametersCalculator";
import { IQuote } from "../interfaces/trade/precificacao/IQuote";
import { IPrecatorio } from "../interfaces/IPrecatorio";

export const MapQuote = {
  ToPricingCalculatorResponse(quote: IQuote ): IPricingCalculatorResponse {
    const response:IPricingCalculatorResponse={...quote.pricing, message: null, isRecalculateValid: true, params:null}
    return response;
  },

  ToPricingCalculatorRequest(quote:IQuote, calculationType: CalculationRequestTypeEnum ): IPricingCalculatorRequest {
    const request: IPricingCalculatorRequest = {
      id: quote?.id ? quote.id : 0,
      calculationRequestType:calculationType,
      price: quote.pricing.price,
      spread:0,
      precatorio : MapToPrecatorioCalculatorDtoRequest(quote.precatorio),
      pricingParameters: MapToPricingParameters(quote),
      idQuote:quote.id
    }
    return request;
  },
}

export function MapToPrecatorioCalculatorDtoRequest(precatorio: IPrecatorio | IPrecatorioCalculator): IPrecatorioCalculator {
  return {
    principal: precatorio ? precatorio.principal : 0,
    baseDate: precatorio ? precatorio.baseDate : null,
    birthDate: precatorio ? precatorio.birthDate : null,
    credorBirthDate: precatorio ? precatorio.credorBirthDate : null,
    cpfCnpj: precatorio ? precatorio.cpfCnpj : null,
    correctionType: {
      id: precatorio ? precatorio.correctionType?.id : 0,
      name: precatorio ? precatorio.correctionType?.name : null,
    },
    court: {
      id: precatorio ? precatorio.court?.id : 0,
      name: precatorio ? precatorio.court?.name : null,
    },
    type: {
      id: precatorio ? precatorio.type?.id : 0,
      name: precatorio ? precatorio.type?.name : null,
    },
    id: precatorio ? precatorio.id : 0,
    interest: precatorio ? precatorio.interest : 0,
    issueDate: precatorio ? precatorio.issueDate : null,
    nature: precatorio ? precatorio.nature : null,
    processCode: precatorio?.processCode,
    processCodeSource: precatorio?.processCodeSource,
    isSeriousIllness: precatorio?.isSeriousIllness
  };
}

function MapToPricingParameters(quote:IQuote): IPricingParametersCalculator {
  return {
    commission: quote.pricing ? quote.pricing?.commission?.officer?.userCommissionCalculated?.percentage ?? quote.pricing?.commission?.officer?.full?.percentage : 0,
    pss:  quote.pricing.pss,
    pssAbsolute: quote.pricing.pssAbsolute,
    isPss: quote.pricing.pss > 0 || quote.pricing.pssAbsolute > 0,
    disbursementCost:quote.pricing.disbursementCost,
    spreadGrossUp: quote.pricing.spreadGrossUp,
    isSpreadGrossUp: quote.pricing.spreadGrossUp !==0? true: false,
    costType:  CostType.percentualCost,
    pdd: quote.pricing.pdd,
    manualPdd: false,
    manualCost: false,
    cost: quote.pricing.percentageCost,
    isManualSettlementMonth:  false,
    manualSettlementMonth:  0,
    isManualMaturityDate: false,
    disbursementDate: quote.pricing?.disbursementDate,
    reducedPercentLender:quote.pricing.reducedPercentLender,
    isReducedPercentLender:quote.pricing.isReducedPercentLender,
    commissionValue:  quote.pricing?.commission?.officer?.userCommissionCalculated?.value ?? quote.pricing?.commission?.officer?.full?.value,
    cashflows: [],
    forceOfficerPrecification: quote?.officer?.id
  };
}



// WEBPACK FOOTER //
// ./src/services/mapper/quote.mapper.ts